export const isCompany = localStorage.getItem('type') === 'company';